import { defaults } from 'react-chartjs-2';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';

import ErrorBoundary from '@layouts/ErrorBoundary';

import store from '@store/store';

import AppRoutes from '@/routes/AppRoutes.js';
import DeploymentFallbackUI from '@/components/DeploymentFallbackUI';
import deploymentDetector from '@/services/deploymentDetector';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '@assets/styles/main.scss';

toast.configure({ autoClose: 3500 });
defaults.font.family = 'Inter';

// Wrapper component to handle deployment state
const AppWithDeploymentDetection = () => {
	const [isDeploying, setIsDeploying] = useState(false);

	useEffect(() => {
		// Subscribe to deployment state changes
		const unsubscribe = deploymentDetector.subscribe((deploying) => {
			setIsDeploying(deploying);
		});

		return () => {
			unsubscribe();
		};
	}, []);

	// When deploying, ONLY show deployment UI
	if (isDeploying) {
		return <DeploymentFallbackUI />;
	}

	return (
		<Provider store={store}>
			<ErrorBoundary>
				<AppRoutes />
			</ErrorBoundary>
		</Provider>
	);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppWithDeploymentDetection />);
